import {serialize} from "object-to-formdata";
import axios from '../axios'

const hasFiles = (data) => {
    return data instanceof File ||
      data instanceof Blob ||
      data instanceof FileList ||
      (typeof data === 'object' && data !== null && Object.values(data).find(value => hasFiles(value)) !== undefined)
  }

const bracketTransformer = [(data) => {
    const hasFile = hasFiles(data)
    if (!hasFile) return data

    let arrays = Object.keys(data)
        .filter(key => Array.isArray(data[key]))
        .reduce((obj, key) => {
            obj[key] = data[key]
            return obj
        }, {})
    let not_arrays = Object.keys(data)
        .filter(key => !Array.isArray(data[key]))
        .reduce((obj, key) => {
            obj[key] = data[key]
            return obj
        }, {})
    console.log('mod', arrays, not_arrays)
    let form = serialize(not_arrays)
    console.log(...form)
    Object.keys(arrays).forEach(key => {
        arrays[key].forEach(arrItem => {
            form.append(key, arrItem)
        })
    })
    console.log(...form)
    return form
}, ...axios.defaults.transformRequest]

export default {
    data(){
        return {
            id: false,
            isModal: true,
            preventClose: false,
            urlKeyName: null,
            bypassMounted: false,
            create_params: {},
            bracketTransform: false,
            copyKeys: [],
        }
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        record: {
            type: Object,
            default: () => ({}),
        },
        url_key: {
            type: String,
            required: true,
        },
        create_event: {
            type: String,
            default: "record-created"
        },
        emit_full_response: {
            type: Boolean,
            default: false
        },
        is_modal: null, //NULL will be ignored
    },
    computed: {
        mdldata(){
            return {
                title: this.title,
                id: this.id,
                isModal: this.isModal,
            }
        }
    },
    created(){
        // is a valid prop is passed, data property isModal will be overriden by default
        if(this.is_modal != null){
            this.isModal = this.is_modal
        }
    },
    mounted() {
        if(this.bypassMounted) return;

        if(this.fetchHelpers && typeof this.fetchHelpers === 'function'){
            this.fetchHelpers()
            // return
        }

        this.edit_()
    },
    methods: {
        edit_() {
            this.id = this.id || this.record?.id;
            if(this.id){
                this.edit()
            }
        },
        edit(){
            this.copyPostKeys()

            this.postEdit()
        },
        copyPostKeys(){
            // const copiedObject = this.copyKeys.length ? this.copyKeys.reduce((acc, key) => ({...acc, [key]: this.record[key]}), {}) : {...this.record};
            // const buildCopiedObject = (source, keys) => {
            //     return keys.reduce((acc, key) => {
            //       if (typeof key === 'string') {
            //         acc[key] = source[key];
            //       } else if (typeof key === 'object' && key !== null) {
            //         for (const nestedKey in key) {
            //           if (source[nestedKey]) {
            //             acc[nestedKey] = buildCopiedObject(source[nestedKey], key[nestedKey]);
            //           }
            //         }
            //       }
            //       return acc;
            //     }, {});
            //   };
            function buildCopiedObject(record, keys) {
              const copiedObject = {};

              keys.forEach(key => {
                if (typeof key === 'string') {
                  copiedObject[key] = record[key];
                } else if (typeof key === 'object' && key !== null) {
                  for (const parent in key) {
                    if (!record[parent]) continue;
                    copiedObject[parent] = {};
                    key[parent].forEach(childKey => {
                      copiedObject[parent][childKey] = record[parent][childKey];
                    });
                  }
                }
              });

              return copiedObject;
            }

            const copiedObject = this.copyKeys.length
            ? buildCopiedObject(this.record, this.copyKeys)
            : { ...this.record };

            this.post.update({
                ...copiedObject
            })
        },
        postEdit(){},
        close(){
            this.$emit('close')
        },
        extraData(){
            return {}
        },
        //methods can be overridden from mixin, if created in component
        getUrl(){
            const url = this.id
                ? this.genUrl(this.url_key, this.id, this.urlKeyName)
                : this.genUrl(this.url_key, null, this.urlKeyName);
            return url
        },
        getMode(){
            const mode = this.id ? "put" : "post";
            return mode
        },
        preCreate(){},
        postCreate(response){},
        create() {
            const pr = this.preCreate()
            if(pr === false) return;
            //   this.startCompLoading();
            this.post[this.getMode()](this.getUrl(), {
                params: this.create_params,
                transformRequest: this.bracketTransform ? bracketTransformer : undefined,
                data: this.extraData(),
            })
                .then(({data}) => {
                    console.log(data)
                    this.toastSuccess();
                    this.postCreate(data)
                    if(!this.preventClose){
                        this.$emit("close");
                    }
                    const emitResponse = this.emit_full_response ? data : this.id
                    this.$root.$emit(this.create_event, emitResponse);
                })
                // .catch((err) => {
                // })
            // .finally(() => this.endCompLoading());
        },
    }
}